"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var api_base_1 = __importDefault(require("./api_base"));
exports.default = {
    get: function (userId) {
        return api_base_1.default.get("users/" + userId).then(function (response) { return response.data.data; });
    },
    query: function () {
        return api_base_1.default.get('users').then(function (response) { return response.data.data; });
    },
    create: function (email, firstName, lastName) {
        return api_base_1.default
            .post('users', { user: { email: email, first_name: firstName, last_name: lastName } })
            .then(function (response) { return response.data.data; });
    }
};
//# sourceMappingURL=users_api.js.map